// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-score-wrapper {
  container-type: inline-size;
  width: 100%;
  height: 100%;
}

.company-score-container {
  position: relative;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  box-sizing: border-box;
  width: 100%;
  min-width: 328px;
  height: 100%;

  display: flex;
  flex-direction: column;

  /* padding: 16px; */
}

.company-score-analysts-rating {
  width: 64px;
  height: 60px;

  border-radius: 1px;
  gap: 10px;

  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 24px;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;
}

.company-score-analysts-rating-container {
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  padding: 24px;
  border-radius: 2px;
  background-color: var(--surface-tertiary);
}

.company-score-analysts-rating-row {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.company-score-info-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--text-primary);
}

.company-score-info-button svg {
  width: 100%;
  height: 100%;
  display: block;
}

.company-score-analysts-rating-container .score10 {
  background-color: var(--surface-invert);
  color: var(--text-invert);
}

.company-score-analysts-rating-container .score {
  background-color: var(--surface-secondary);
  color: var(--text-primary);
}

.company-score-analysts-rating-ranking {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-primary);
}

.company-score-analysts-rating-ranking-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: block;
}

.company-score-analysts-rating-ranking-text {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
}

.company-score-analysts-rating-text {
  width: 100%;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
}

.company-score-chart-container {
  flex: 1;
}

@container (min-width: 768px) {
  .company-score-container {
    flex-direction: row;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/CompanyScoreWidget/CompanyScoreWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;;EAEZ,aAAa;EACb,sBAAsB;;EAEtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,kBAAkB;EAClB,SAAS;;EAET,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".company-score-wrapper {\n  container-type: inline-size;\n  width: 100%;\n  height: 100%;\n}\n\n.company-score-container {\n  position: relative;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 328px;\n  height: 100%;\n\n  display: flex;\n  flex-direction: column;\n\n  /* padding: 16px; */\n}\n\n.company-score-analysts-rating {\n  width: 64px;\n  height: 60px;\n\n  border-radius: 1px;\n  gap: 10px;\n\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 24px;\n  text-align: center;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.company-score-analysts-rating-container {\n  flex: 1;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  padding: 24px;\n  border-radius: 2px;\n  background-color: var(--surface-tertiary);\n}\n\n.company-score-analysts-rating-row {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.company-score-info-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--text-primary);\n}\n\n.company-score-info-button svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.company-score-analysts-rating-container .score10 {\n  background-color: var(--surface-invert);\n  color: var(--text-invert);\n}\n\n.company-score-analysts-rating-container .score {\n  background-color: var(--surface-secondary);\n  color: var(--text-primary);\n}\n\n.company-score-analysts-rating-ranking {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-primary);\n}\n\n.company-score-analysts-rating-ranking-icon {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  display: block;\n}\n\n.company-score-analysts-rating-ranking-text {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.company-score-analysts-rating-text {\n  width: 100%;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.company-score-chart-container {\n  flex: 1;\n}\n\n@container (min-width: 768px) {\n  .company-score-container {\n    flex-direction: row;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
